import { apiRequest } from '../client';
import { getApiToken } from '../authToken';
import { toJsonSafe } from '../json';

export function asMeeting(row) {
  if (!row) return null;
  const dateTime = row.dateTime ? new Date(row.dateTime) : null;
  const endTime = row.endTime ? new Date(row.endTime) : null;
  return {
    ...row,
    type: 'meeting',
    dateTime: dateTime && !Number.isNaN(dateTime.getTime()) ? dateTime : null,
    endTime: endTime && !Number.isNaN(endTime.getTime()) ? endTime : null,
    archived: Boolean(row.archived),
  };
}

export async function listMeetings({ companyId, from, to, archived, status, token } = {}) {
  const authToken = token || (await getApiToken());
  const params = new URLSearchParams();
  if (from) params.set('from', from instanceof Date ? from.toISOString() : String(from));
  if (to) params.set('to', to instanceof Date ? to.toISOString() : String(to));
  if (archived != null) params.set('archived', String(archived));
  if (status) params.set('status', status);
  const query = params.toString();
  const path = `/api/companies/${encodeURIComponent(companyId)}/meetings${query ? `?${query}` : ''}`;
  const result = await apiRequest(path, { token: authToken });
  return (result.meetings || []).map(asMeeting);
}

export async function getMeeting({ companyId, id, token }) {
  const authToken = token || (await getApiToken());
  const result = await apiRequest(
    `/api/companies/${encodeURIComponent(companyId)}/meetings/${encodeURIComponent(id)}`,
    { token: authToken }
  );
  return asMeeting(result.meeting);
}

export async function createMeeting({ companyId, meeting, token }) {
  const authToken = token || (await getApiToken());
  const result = await apiRequest(`/api/companies/${encodeURIComponent(companyId)}/meetings`, {
    token: authToken,
    method: 'POST',
    body: { meeting: toJsonSafe(meeting) },
  });
  return asMeeting(result.meeting);
}

export async function upsertMeeting({ companyId, id, meeting, token }) {
  const authToken = token || (await getApiToken());
  const result = await apiRequest(
    `/api/companies/${encodeURIComponent(companyId)}/meetings/${encodeURIComponent(id)}`,
    {
      token: authToken,
      method: 'PUT',
      body: { meeting: toJsonSafe(meeting) },
    }
  );
  return asMeeting(result.meeting);
}
